<template>
    <div>
        <div class="container">
            <article v-for="item in cartDetail.items" :key="item.id" class="media">
                <figure class="media-left">
                    <p class="image is-64x64">
                        <img :src="item.image" alt="">
                    </p>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <strong>{{item.productTitle}}</strong>
                        <p class="heading"><span v-for="(val, i) in item.valueNames" :key="i">{{val}}, </span></p>
                        <p class="heading">{{item.currencySymbol}}{{item.unitPrice}} x{{item.quantity}}</p>
                    </div>
                </div>
                <div class="media-right">
                    <p>{{item.currencySymbol}}{{item.total}}</p>
                </div>
            </article>
        </div>
        <div class="container m-t-20">
            <div class="level has-text-left is-mobile">
                <div class="level-item">
                    <div>
                        <p class="heading">Subtotal</p>
                        <p>UY${{cartDetail.subtotalTaxInUy[0]}}</p>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading">Impuesto</p>
                        <p>UY${{cartDetail.subtotalTaxInUy[1]}}</p>
                    </div>
                </div>
                <div class="level-item">
                    <div>
                        <p class="heading"><strong>Total</strong></p>
                        <p><strong>UY${{cartDetail.totalInUy}}</strong> </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getHandler, debounce, patchHandler, deleteHandler} from "./../../../../services/http"
export default {
    props:{
        cartDetail:{
            type:Object,
            default: new Object({})
        },
        loading:{
            type:Boolean,
            default:false
        },
        shipmentTotalUy:{
            type:Number,
            default:0,
        },
        shipmentTotalUsd:{
            type:Number,
            default:0
        },
        amountUsd:{
            type:Number,
            default:0
        },
        amountUy:{
            type:Number,
            default:0,
        },
    },
    methods:{
        fetchCartDetails(){
            this.$emit("fetchCart")
        },
        async deleteCartItem(item){
            var err={
                resource:"toast",
                text:"Algo salio mal... intentalo otra vez"
            }
            var succ={
                resource:"toast",
                text:"Producto eliminado del carro."
            }
            
            var resp = await deleteHandler(item.getDetailRestUrl, {error:err, success:succ})
            this.fetchCartDetails()
            
        },
        updateCartItem: debounce(
            async function(item,context=this){
               var err={
                    resource:"toast",
                    text:"Algo salio mal... intentalo otra vez"
                }
                var succ={
                    resource:"toast",
                    text:"Producto actualizado con exito."
                }
                if(item.quantity > 0){
                    let res = await patchHandler(item.getDetailRestUrl, item, {error:err, success:succ})
                    console.log(res)
                    if (res.status == 200 || res.status == 201){
                        this.fetchCartDetails()
                    }
                }
            }, 300
        )

    },
    created(){
        this.fetchCartDetails()
    }
}
</script>

<style lang="scss" scoped>
.main-sect{
    @media(min-width: 1023px){
        margin-top:20px;
    }
}

.card{
    border:0px #fff solid !important;
    border-radius: 20px;
    box-shadow: 1px 10px 10px rgba(184, 184, 184, 0.55);
}

.is-custom{
    background:var(--primary);
    color:var(--text-color);
}

.image{
    img{
        border-radius:5px;
    }
}

</style>